<div class="content layout vertical center middle" style="width: 100%; text-align: center;">
    <h1>Utente senza permessi</h1>
</div>